module.exports = __webpack_public_path__ + "img/red.481cf656.gif";